/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { CompanyUserStore } from './company-user-store';

export const CompanyWizardStoreContext = createContext<CompanyUserStore>({} as CompanyUserStore);
